module.exports = __webpack_public_path__ + "img/ertiga-glx.4f84e8ea.png";